import { localDateToUtc, utcToLocalDate } from '@front-app/hooks/DataDashboard/util';
import { API_V2 } from '@front-app/services/api';
import endOfDay from 'date-fns/endOfDay';
import {
	DataCount,
	GroupDataResponse,
	GroupDataType,
	GroupDataBucket,
	GroupsDataResponse,
} from './GroupDataModel';

export interface GroupDataDashboardRequest {
	groupIds: string[];
	dataType: GroupDataType;
	bucketSize: GroupDataBucket;
	categoryNames: string[];
	dateTimeStart: Date;
	dateTimeEnd: Date;
	aggregateGroups: boolean;
}

export function getGroupDataDashboardData(params: GroupDataDashboardRequest): Promise<GroupsDataResponse> {
	return API_V2.get('/groups/data', {
		params: {
			...params,
			dateTimeEnd: localDateToUtc(endOfDay(params.dateTimeEnd)),
		},
	})
		.then(({ data }) => data as GroupsDataResponseExternal)
		.then((data) => Object.entries(data)
			.reduce<GroupsDataResponse>((acc, [key, val]) => {
				acc[key] = val.map(parseData);
				return acc;
			}, {}));
}

type GroupsDataResponseExternal = Record<string, GroupDataResponseExternal[]>;

interface GroupDataResponseExternal extends Omit<GroupDataResponse, 'dataPoints'> {
	dataPoints: DataCountExternal[];
}

interface DataCountExternal extends Omit<DataCount, 'date'> {
	date: string;
}

function parseData(data: GroupDataResponseExternal): GroupDataResponse {
	return {
		keyName: data.keyName,
		totalBeforeStart: data.totalBeforeStart,
		dataPoints: data.dataPoints.map(({ date, count }) => ({ date: utcToLocalDate(new Date(date)), count })),
	};
}
